import { observable, set, action } from 'mobx';
import { IGeneralKeys } from '../../views/product-filters/IProductFilters';
import { IAnalyticsAppliedFilters } from '../../controllers/ProductGridViewController';

export class Filter {
    @observable public label: string;
    @observable public key: string;
    @observable public id: string;
    @observable public active: boolean = false;
    @observable public category: string;

    constructor(filterJson: IGeneralKeys, category: string, isDefaultSelected: boolean = false) {
        set(this, filterJson);
        this.category = category;
        this.active = isDefaultSelected;
    }

    public passes(comparisonValue: string[]): boolean {
        return comparisonValue.indexOf(this.key) > -1;
    }

    @action
    public toggleActiveState = () => {
        this.active = !this.active;
    };

    @action
    public setActiveState = (newState: boolean) => {
        this.active = newState;
    };

    public static toJson(filter: Filter): IAnalyticsAppliedFilters {
        return {
            category: filter.category,
            option: filter.label
        };
    }
}
